<div>
  <div class="main-menu" id="main-menu">
    <div class="menu-search" *ngIf="orgTypeId === 1">
      <div class="menu-search-box">
        <i class="fa fa-search"></i>
        <input
          #searchInput
          type="text"
          placeholder="Search pages"
          [(ngModel)]="searchTerm"
          (ngModelChange)="search()"
          (keydown)="onSearchKeydown($event)"
        />
        <i class="fa fa-times menu-search-clear" *ngIf="searchTerm" (click)="clearSearch()"></i>
      </div>
    </div>

    <ul class="ultima-menu menu-search-results" *ngIf="searchTerm">
      <li *ngFor="let result of searchResults; let i = index">
        <a
          [routerLink]="result.routerLink"
          [class.menu-search-active]="i === activeResultIndex"
          (click)="onNavigate(result)"
        >
          <span>{{ result.label }}</span>
          <i
            class="fa fa-thumb-tack menu-pin"
            *ngIf="menuPinService.enabled"
            [class.pinned]="menuPinService.isPinned(result.routerLink)"
            (click)="menuPinService.toggle($event, result.routerLink)"
          ></i>
          <div class="menu-path" *ngIf="result.path">{{ result.path }}</div>
        </a>
      </li>
      <li class="menu-search-empty" *ngIf="!searchResults.length">No matching pages</li>
    </ul>

    <div [hidden]="searchTerm">
      <ng-container *ngIf="menuPinService.pinnedItems.length">
        <div class="menu-section-title">Pinned</div>
        <ul class="ultima-menu menu-pinned">
          <li *ngFor="let pin of menuPinService.pinnedItems">
            <a
              [routerLink]="pin.routerLink"
              routerLinkActive="active-menuitem-routerLink"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="onNavigate(pin)"
            >
              <span>{{ pin.label }}</span>
              <i
                class="fa fa-thumb-tack menu-pin pinned"
                title="Unpin"
                (click)="menuPinService.toggle($event, pin.routerLink)"
              ></i>
              <div class="menu-path" *ngIf="pin.path">{{ pin.path }}</div>
            </a>
          </li>
        </ul>
      </ng-container>

      <ul
        app-submenu
        [item]="model"
        root="true"
        class="ultima-menu ultima-main-menu clearfix"
        [reset]="reset"
        visible="true"
      ></ul>
    </div>
  </div>

  <div class="footer">
    <div class="container">
      <div class="links">
        <div style="display: flex; grid-gap: 10px">
          <div style="flex-grow: 1; color: white; font-weight: bold; margin-bottom: 12px">
            {{ userName }}
          </div>
          <div style="flex-shrink: 1" *ngIf="orgTypeId == 2">
            <img style="width: 60px" *ngIf="logo" class="logo" src="{{ logo }}" />
          </div>
        </div>
        <div *ngIf="orgTypeId != 2; else customerSDContact">
          <div style="font-size: 14px"><b>More Information</b></div>
          <div style="font-size: 13px">☏ {{ systemSettings?.engineiusPhone }}</div>
          <div style="font-size: 13px">
            <a href="mailto:{{ systemSettings?.defaultSupplierSupportEmail }}">Email</a>
            |
            <a [ngClass]="'terms'" (click)="termsService.downloadTermsOfUse()">Terms of Use</a>
          </div>
        </div>
        <ng-template #customerSDContact>
          <div>
            <div>
              <a href="https://www.engineius.co.uk/customer-guides-new" target="_blank">
                <button class="help-button">
                  <i class="fa fa-question-circle"></i
                  ><span style="margin-left: 5px"><b>Help</b></span>
                </button>
              </a>
            </div>
            <div style="font-size: 14px"><b>More Information</b></div>
            <div style="font-size: 13px">
              ☏ {{ organisation.serviceDeliveryGroup?.telephone || systemSettings?.engineiusPhone }}
            </div>
            <div style="font-size: 13px">
              <a href="mailto:{{ systemSettings?.defaultCustomerSupportEmail }}">
                {{ systemSettings?.defaultCustomerSupportEmail }}
              </a>
            </div>
          </div>
        </ng-template>
        <div style="font-size: 13px">
          <a href="https://www.engineius.co.uk/privacypolicy/">Privacy & Cookie Policy</a>
        </div>
        <br />
        <div *ngIf="orgTypeId != 5" style="font-size: 14px"><b>Powering Vehicle Movement</b></div>
        <div *ngIf="orgTypeId == 5" style="margin-bottom: 6px">
          <img
            src="https://s3.eu-west-2.amazonaws.com/bucket.engineius.portal-static-content/engynn/poweredByEngineius.svg"
            alt="Powered by Engineius"
            style="width: 160px; filter: brightness(0) invert(1)"
          />
        </div>
        <div style="font-size: 13px">
          © {{ date.getFullYear() }} Engineius (V{{ bbwtVersion2 }})
        </div>
      </div>
    </div>
  </div>
</div>
